import moment from 'moment'

import { getPersistedOTP } from '../../store/persist'
import { DefaultRootState } from 'react-redux'

export const isOTPValid = (state: DefaultRootState, username: string) => {
  const otpByUsername = getPersistedOTP(state)[username.toLowerCase()] || {}
  const { hash, expire } = otpByUsername
  return hash && moment(expire).isSameOrAfter(moment())
}
